import {Component, forwardRef, Input, Optional} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbinputConfig, NbFieldType} from './nbinput.entity';

@Component({
  selector: 'nbinput-froala',
  template: require('./nbinput-froala.component.html'),
  styles: [require('./nbinput-froala.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputFroalaComponent),
      multi: true
    }
  ]
})

export class NbinputFroalaComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  _config: NbinputConfig = new NbinputConfig();
  @Input()
  set config (v) {
    if (v){
        this._config = v;
        this.refreshOption();
    }
  }
  get config () {
    return this._config;
  }
  refreshOption() {
    this.options = {
      placeholderText: '点击这里开始输入',
      imageUploadURL: this._config.uploadAPI + '?token=' + this._config.token,
      imageUploadParams: {token: this._config.token},
      language: 'zh_cn',
      events : {
        'froalaEditor.image.uploaded' : (e, editor, response) => {
          try {
            const resp = JSON.parse(response);
            const url = resp && resp.data ? resp.data.url : '';
            editor.image.insert(
              (this._config ? this._config.downloadAPI : '') + url + (this._config.token && this._config.token.length > 0 ? '?token=' + this._config.token : '')
              , false, null, editor.image.get(), response);
          } catch (f) {
            console.warn('文件上传失败：', f)
          }
          return false;
        }
      }
    };
  }

  public options;

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  @Input()
  public data = '';
  @Input()
  public disabled;

  @Input()
  public placeholder;

  @Input()
  public type: NbFieldType = NbFieldType.Html;
  @Input()
  public readonly = false;

  registerOnChange(fn: any): void {if (fn) {this.onChangeCallback = fn; }}
  registerOnTouched(fn: any): void {if (fn) {this.onTouchedCallback = fn; }}
  setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
  writeValue(obj): void {
    if (obj) {
      this.data = obj;
    }
  }
  onChange(e) {
    this.onChangeCallback(e);
  }
  constructor(
  ) {
    this.refreshOption();
  }
}

